import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DEFAULT_SEO, PAGE_SEO, SITE_NAME, SITE_URL } from "@/lib/seo";

function upsertMeta(attr, key, content) {
  if (!content) return;
  try {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  } catch (err) {
    console.warn(err);
  }
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function pageUrl(origin, pathname) {
  if (pathname === "/") return `${origin}/`;
  return `${origin}${pathname}`;
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = PAGE_SEO[pathname] || DEFAULT_SEO;
    const origin = SITE_URL;
    const url = pageUrl(origin, pathname);
    const image = `${origin}${seo.image || DEFAULT_SEO.image}`;

    document.title = seo.title;
    document.documentElement.lang = "tr";

    upsertMeta("name", "description", seo.description);
    upsertMeta("name", "keywords", seo.keywords);
    upsertMeta("name", "author", SITE_NAME);
    upsertMeta("name", "robots", "index, follow");

    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:locale", "tr_TR");
    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:title", seo.title);
    upsertMeta("property", "og:description", seo.description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:image:alt", seo.title);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", seo.title);
    upsertMeta("name", "twitter:description", seo.description);
    upsertMeta("name", "twitter:image", image);

    upsertLink("canonical", url);
  }, [pathname]);

  return null;
}
